class FeaturedCollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-featured-collection-tab]');
    this.panels = this.querySelectorAll('[data-featured-collection-panel]');
    this.titleEl = this.querySelector('[data-featured-collection-title]');
    this.descriptionEl = this.querySelector('[data-featured-collection-description]');
    this.headerViewAll = this.querySelector('[data-featured-collection-header-view-all]');
    this.headerViewAllWrapper = this.headerViewAll
      ? this.headerViewAll.closest('.collection__view-all')
      : null;

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    const panelIndex = tab.dataset.featuredCollectionTab;

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.featuredCollectionPanel === panelIndex;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        const slider = panel.querySelector('slider-component');
        if (slider && typeof slider.resetPages === 'function') {
          slider.resetPages();
        }
        window.dispatchEvent(new Event('resize'));
      }
    });

    const titleTemplate = this.querySelector(
      `template[data-featured-collection-title="${panelIndex}"]`
    );
    if (this.titleEl && titleTemplate) {
      this.titleEl.innerHTML = titleTemplate.innerHTML.trim();
      this.titleEl.hidden = this.titleEl.innerHTML.length === 0;
    }

    const descriptionTemplate = this.querySelector(
      `template[data-featured-collection-description="${panelIndex}"]`
    );
    if (this.descriptionEl) {
      if (descriptionTemplate && descriptionTemplate.innerHTML.trim().length > 0) {
        this.descriptionEl.innerHTML = descriptionTemplate.innerHTML;
        this.descriptionEl.hidden = false;
      } else {
        this.descriptionEl.innerHTML = '';
        this.descriptionEl.hidden = true;
      }
    }

    if (this.headerViewAll && this.headerViewAllWrapper) {
      if (tab.dataset.viewAllUrl && tab.dataset.showViewAll === 'true') {
        this.headerViewAll.href = tab.dataset.viewAllUrl;
        if (tab.dataset.viewAllLabel) {
          this.headerViewAll.setAttribute('aria-label', tab.dataset.viewAllLabel);
        }
        this.headerViewAllWrapper.hidden = false;
      } else {
        this.headerViewAllWrapper.hidden = true;
      }
    }
  }
}

customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
